import { type ICompanyBillingQuery } from 'application/querySchemas/ICompanyBillingQuery';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import {
    type ICompanyBillingListClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/ICompanyBillingListClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class CompanyBillingQuery implements ICompanyBillingQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyBillingListClient')
        public readonly companyBillingListClient: ICompanyBillingListClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.companyBillingListClient.get({
            token: this.companyUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
